import { render, staticRenderFns } from "./CompanyRLSDownloadButton.vue?vue&type=template&id=33639a34"
import script from "./CompanyRLSDownloadButton.vue?vue&type=script&lang=js"
export * from "./CompanyRLSDownloadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports